import axios from "./index";

class ComunicacionesApi {
  //COMUNICACIONES
  static obtenerComunicacionesSoft = () => {
    return axios.get(`/procesos/comunicaciones/soft/`);
  };
  static obtenerComunicacionesProcesoSoft = (procesoId) => {
    return axios.get(`/procesos/comunicaciones/${procesoId}/soft/`);
  };
  static fetchComunicacionesPaginacion = (params = {}) => {
    return axios.get(`/procesos/comunicaciones/paginacion/`, { params });
  };
  static obtenerComunicacionById = (comunicacionId, procesoId) => {
    return axios.get(`/procesos/comunicaciones/${procesoId}/${comunicacionId}/`);
  };
  static obtenerDestinatarios = (id) => {
    return axios.get(`/procesos/comunicaciones/${id}/obtenerDestinatarios`);
  };
  static operarComunicacion = (data) => {
    return axios.post(`/procesos/comunicaciones/operarComunicacion/`, data);
  };
  static notificarComunicacion = (comunicacionId, selectedDestinatarios) => {
    return axios.post(
      `/procesos/comunicaciones/${comunicacionId}/ejecutar/`,
      selectedDestinatarios
    );
  };
  static crearComunicacion = (procesoId, data) => {
    return axios.post(`/procesos/${procesoId}/comunicaciones/registrar/`, data);
  };
  // INFORME DE ESTADO DEL PROCESO (memorial a juzgados)
  static obtenerDatosInformeEstado = (procesoId) => {
    return axios.get(`/procesos/${procesoId}/comunicaciones/informeEstado/`);
  };
  static previsualizarInformeEstado = (procesoId, data) => {
    return axios.post(`/procesos/${procesoId}/comunicaciones/informeEstado/previsualizar/`, data, {
      responseType: "blob",
    });
  };
  static registrarInformeEstado = (procesoId, data) => {
    return axios.post(`/procesos/${procesoId}/comunicaciones/informeEstado/registrar/`, data);
  };

  static actualizarComunicacion = (id, data) => {
    return axios.put(`/procesos/comunicaciones/${id}/actualizar/`, data);
  };

  static eliminarComunicacion = (id) => {
    return axios.delete(`/procesos/comunicaciones/${id}/eliminar/`);
  };

  static generateComunicacionPdf(
    comunicacionId,
    options = {},
    timestamp = null,
    destinatarioNombre = null,
    destinatarioId = null,
    tipoDestinatario = null
  ) {
    let url = `/pdf/comunicaciones/${comunicacionId}/generar-pdf/`;

    // Construir query params
    const params = new URLSearchParams();
    if (timestamp) {
      params.append("t", timestamp);
    }
    if (destinatarioNombre) {
      params.append("destinatario_nombre", destinatarioNombre);
    }
    if (destinatarioId) {
      params.append("destinatario_id", destinatarioId);
    }
    if (tipoDestinatario) {
      params.append("tipo_destinatario", tipoDestinatario);
    }

    // Agregar params a la URL si existen
    if (params.toString()) {
      url += `?${params.toString()}`;
    }

    return axios.get(url, {
      ...options,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        // REMOVER estos headers que causan el error CORS:
        // "Cache-Control": 'no-cache, no-store, must-revalidate',
        // "Pragma": 'no-cache',
        // "Expires": '0',
      },
    });
  }
}

export default ComunicacionesApi;
